import * as yup from "yup";
import { alphabet_regix, arabic_text_regix, numeric_decimal_regix, numeric_integer_regix, splitPhoneNumberAndCode } from "../utils/functions";

export const empty_manager = {
    name: "",
    birthDate: "",
    identificationId: "",
    identificationType: null,
    nationalityId: "",
    corpClientApplicationManagerId: 0,
    isNameFetchByWathq: false,
    isBirthDateFetchByWathq: false,
    isIdentificationIdFetchByWathq: false,
    isIdentificationTypeFetchByWathq: false,
    isNationalityIdFetchByWathq: false,
};

export const general_information_schema = (data) => ({
    corpClientApplicationGeneralinformationId: data?.corpClientApplicationGeneralinformationId ?? 0,
    commercialRegistrationName: data?.commercialRegistrationName ?? "",
    commercialRegistrationNameEn: data?.commercialRegistrationNameEn ?? "",
    commercialRegistrationNo: data?.commercialRegistrationNo ?? "",
    expiryDateOfCR: data?.expiryDateOfCR ?? "",
    expiryDateOfCRGRG: data?.expiryDateOfCRGRG ?? "",
    unifiedNumber: data?.unifiedNumber ?? "",
    countryOfRegistration: data?.countryOfRegistration ?? null,
    dateOfIncorporation: data?.dateOfIncorporation ?? "",
    dateOfIncorporationGRG: data?.dateOfIncorporationGRG ?? "",
    countryOfPracticingBusiness: data?.countryOfPracticingBusiness ?? null,
    paidUpCapital: data?.paidUpCapital ?? "",
    annualTurnover: data?.annualTurnover ?? "",
    noOfEmployees: data?.noOfEmployees ?? "",
    phoneCountry: data?.phoneNumber ? splitPhoneNumberAndCode(data?.phoneNumber)?.country : "",
    phoneNumber: data?.phoneNumber ? splitPhoneNumberAndCode(data?.phoneNumber)?.number : "",
    faxCountry: data?.faxNumber ? splitPhoneNumberAndCode(data?.faxNumber)?.country : "",
    faxNumber: data?.faxNumber ? splitPhoneNumberAndCode(data?.faxNumber)?.number : "",
    legalStructure: data?.legalStructure ?? null,
    legalStructureOther: data?.legalStructureOther ?? "",
    nameOfAllNaturalPersonsWhoOwnOrControlCompanyShares: data?.nameOfAllNaturalPersonsWhoOwnOrControlCompanyShares ?? "",
    mainActivityList: data?.mainActivityList ?? "",
    managerList: data?.managerList ?? [],
});

export const general_information_validation_schema = yup.object().shape({
    commercialRegistrationName: yup
        .string()
        // .required("commercial_registration_name_required")
        .matches(arabic_text_regix, "characters_should_be_in_arabic"),
    commercialRegistrationNameEn: yup
        .string()
        // .required("commercial_registration_name_en_required")
        .matches(alphabet_regix, "characters_should_be_alphabets"),
    commercialRegistrationNo: yup
        .string(),
        // .required("commercial_registration_no_required"),
    expiryDateOfCR: yup
        .string(),
        // .required("expiry_date_of_cr_required"),
    unifiedNumber: yup
        .string(),
        // .required("unified_number_required"),
    countryOfRegistration: yup
        .number().nullable(),
        // .required("country_of_registration_required"),
    dateOfIncorporation: yup
        .string(),
        // .required("date_of_incorporation_required"),
    countryOfPracticingBusiness: yup
        .number().nullable(),
        // .required("country_of_practicing_business_required"),
    paidUpCapital: yup
        .string()
        // .required("paid_up_capital_required")
        .matches(numeric_decimal_regix, "input_should_be_numeric")
        .test("not-zero", "value_cannot_be_zero", (value) => !value || Number(value) !== 0),
    annualTurnover: yup
        .string()
        // .required("annual_turnover_required")
        .matches(numeric_decimal_regix, "input_should_be_numeric")
        .test("not-zero", "value_cannot_be_zero", (value) => !value || Number(value) !== 0)
        .nullable(),
    noOfEmployees: yup
        .string()
        .matches(numeric_integer_regix, "input_should_be_numeric")
        .test("not-zero", "value_cannot_be_zero", (value) => !value || Number(value) !== 0)
        .nullable(),
    phoneNumber: yup
        .string(),
        // .required("phone_number_required"),
    faxNumber: yup
        .string(),
        // .required("fax_number_required"),
    // mainActivityList: yup
    //     .string()
    //     .required("main_activity_required")
    //     .matches(alphabet_regix, "characters_should_be_alphabets"),
    nameOfAllNaturalPersonsWhoOwnOrControlCompanyShares: yup
        .string()
        // .required("name_of_natural_persons_required")
        .matches(alphabet_regix, "input_should_be_alphabets")
        .nullable(),
    legalStructure: yup
        .number()
        .nullable(),
        // .required("legal_structure_required")
        // .test("legal-structure-selected", "at_least_one_option_should_be_selected", (value) => value !== null && value !== undefined),
});

export const manager_add_validation_schema = yup.object().shape({
    name: yup
        .string()
        .required("name_required")
        .matches(alphabet_regix, "characters_should_be_alphabets"),
    identificationId: yup
        .string()
        .required("identification_id_required"),
    identificationType: yup
        .string()
        .required("identification_type_required"),
    nationalityId: yup
        .string()
        .required("country_required"),
});
